import { render, staticRenderFns } from "./RGBLight.vue?vue&type=template&id=1bf7f0ce&scoped=true&"
import script from "./RGBLight.vue?vue&type=script&lang=js&"
export * from "./RGBLight.vue?vue&type=script&lang=js&"
import style0 from "./RGBLight.vue?vue&type=style&index=0&id=1bf7f0ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf7f0ce",
  null
  
)

export default component.exports